import * as React from "react";
import { Link } from 'react-router-dom';
function SellMyHome(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement("a", {
    id: "cta-1",
    href: true,
    className: "px-5 py-4 no-underline cta-hover icon-fill",
    style: {
      borderTopLeftRadius: '0.25rem !important',
      borderBottomLeftRadius: '0.25rem !important'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 65,
    width: 65,
    style: {
      marginBottom: '-19px'
    },
    alt: "for sale icon",
    className: "mx-auto d-block",
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 51"
  }, /*#__PURE__*/React.createElement("style", {
    className: 'htmlToNative',
    type: "text/css",
    dangerouslySetInnerHTML: {
      __html: "\n                    .cta1-0 {\n                        fill: none;\n                        stroke-width: 1.5;\n                    }\n\n                    .cta1-1 {\n                        fill-rule: evenodd;\n                        clip-rule: evenodd;\n                    }\n\n                    .cta1-2 {\n                        fill-rule: evenodd;\n                        clip-rule: evenodd;\n                    }\n\n                    .cta1-3 {\n                        filter: url(#Adobe_OpacityMaskFilter);\n                    }\n\n                    .cta1-4 {\n                        fill-rule: evenodd;\n                        clip-rule: evenodd;\n                        fill: #FFFFFF;\n                    }\n\n                    .cta1-5 {\n                        mask: url(#mask-2_00000075850803038374858620000007343692463584097924_);\n                        fill-rule: evenodd;\n                        clip-rule: evenodd;\n                    }\n                "
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_x2F_positive_x2F_for-sale"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(4.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Stroke-1",
    className: "cta1-0 stroke-dark",
    x1: 38,
    y1: 28,
    x2: -4,
    y2: 28
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "cta1-1 fill-light-cyan",
    points: "25.7,22.9 28.1,22.9 28.1,-7 25.7,-7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    className: "cta1-1 fill-light-cyan",
    points: "14.2,-4.6 28.1,-4.6 28.1,-7 14.2,-7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "cta1-1 fill-light-cyan",
    points: "14.2,6.8 16.6,6.8 16.6,-7 14.2,-7    "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cta1-2 fill-cyan",
    d: "M32,14.3H1.4c-0.8,0-1.4-0.6-1.4-1.4V-1.4c0-0.8,0.6-1.4,1.4-1.4H32c0.8,0,1.4,0.6,1.4,1.4v14.3\r\n        C33.4,13.6,32.8,14.3,32,14.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(4.028156, 4.163957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -4,
    y: -7,
    width: "33.4",
    height: "17.1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -7,
    width: "33.4",
    height: "17.1",
    id: "mask-2_00000075850803038374858620000007343692463584097924_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cta1-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000152985556804155392500000007054273704212707505_",
    className: "cta1-4",
    d: "M-2.5-7C-3.3-7-4-6.3-4-5.5l0,0V8.6\r\n              c0,0.8,0.7,1.5,1.5,1.5l0,0h30.4c0.8,0,1.5-0.7,1.5-1.5l0,0V-5.5c0-0.8-0.7-1.5-1.5-1.5l0,0H-2.5z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "cta1-5 fill-dark-cyan",
    points: "29.4,10.1 -4,10.1 29.4,-7       "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(8.982461, 5.930020)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    className: "cta1-4",
    points: "-1.8,-5.5 -1.8,-4.1 1.1,-4.1 1.1,-2.7 -1.8,-2.7 -1.8,-0.6 -3.6,-0.6 -3.6,-6.9\r\n          1.4,-6.9 1.4,-5.5       "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "cta1-4",
    d: "M7.2-3.7c0-1.1-0.8-1.8-1.7-1.8S3.7-4.8,3.7-3.7c0,1.1,0.8,1.8,1.7,1.8S7.2-2.6,7.2-3.7\r\n           M1.9-3.7C1.9-5.6,3.4-7,5.4-7S9-5.6,9-3.7c0,1.9-1.5,3.3-3.5,3.3S1.9-1.8,1.9-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "cta1-4",
    d: "M12.7-5.5h-1v1.8h1c0.7,0,1.1-0.3,1.1-0.9C13.8-5.1,13.5-5.5,12.7-5.5L12.7-5.5z M12.7-2.2h-1\r\n          v1.7H9.9v-6.3h2.9c1.7,0,2.8,0.9,2.8,2.3c0,0.9-0.5,1.6-1.2,2l1.4,2h-1.9L12.7-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "cta1-4",
    d: "M-4,6.2l0.6-1.3C-2.8,5.3-2,5.5-1.3,5.5c0.7,0,1-0.2,1-0.5c0-1-3.6-0.3-3.6-2.6\r\n          c0-1.1,0.9-2,2.8-2c0.8,0,1.7,0.2,2.3,0.5L0.7,2.2C0.1,1.9-0.5,1.7-1.1,1.7c-0.8,0-1,0.3-1,0.6c0,1,3.6,0.2,3.6,2.6\r\n          c0,1.1-0.9,2-2.8,2C-2.4,6.9-3.4,6.6-4,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "cta1-4",
    d: "M6.1,4.3l-0.8-2l-0.8,2H6.1z M6.6,5.6H3.9L3.4,6.8H1.6l2.8-6.3h1.8L9,6.8H7.1L6.6,5.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    className: "cta1-4",
    points: "9.5,0.5 11.3,0.5 11.3,5.4 14.3,5.4 14.3,6.8 9.5,6.8       "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    className: "cta1-4",
    points: "20.1,5.4 20.1,6.8 15,6.8 15,0.5 20,0.5 20,1.9 16.8,1.9 16.8,2.9 19.6,2.9 19.6,4.3\r\n          16.8,4.3 16.8,5.4       "
  }))))), /*#__PURE__*/React.createElement(Link, {
    to: '/Payoff/SellMyHome',
    onClick: function () {
      return onClick(translations.SellMyHome);
    },
    id: "cta-1-btn",
    className: "btn btn-lg px-3 py-2 smaller text-uppercase bg-pennymac-yellow font-weight-bold text-pennymac-black mt-3"
  }, translations.SellMyHome, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })));
}
function PurchaseaNewHome(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement("a", {
    id: "cta-2",
    href: true,
    className: "px-5 py-4 no-underline cta-hover icon-fill",
    style: {
      borderLeft: '1px solid #31AFDF'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 54,
    height: 54,
    alt: "new home icon",
    style: {
      marginTop: '-6px',
      marginBottom: '-2px'
    },
    className: "mx-auto d-block",
    viewBox: "0 0 65 63",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "811FB8EA-EB50-47AE-8F73-1BD311BDA7CC"), /*#__PURE__*/React.createElement("g", {
    id: "navigation-drawers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/desktop/drawer/buy-home",
    transform: "translate(-371.000000, -315.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(0.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(365.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(0.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(6.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.371070, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "fill-dark-cyan",
    points: "43.757699 30.6854952 21.8789305 30.6854952 21.8789305 8.78518948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5674362,45.1703394 L35.5674362,39.2709034 C35.5674362,38.9786328 35.3310431,38.7420071 35.03906,38.7420071 L29.1454255,38.7420071 C28.8534423,38.7420071 28.6165096,38.9786328 28.6165096,39.2709034 L28.6165096,45.1703394 C28.6165096,45.46261 28.8534423,45.6992358 29.1454255,45.6992358 L35.03906,45.6992358 C35.3310431,45.6992358 35.5674362,45.46261 35.5674362,45.1703394 L35.5674362,45.1703394 Z M43.7575371,30.6853871 L43.7575371,53.9660096 L0,53.9660096 L0,30.6853871 L21.8787686,8.78508143 L21.8787686,30.6853871 L43.7575371,30.6853871 Z",
    id: "Fill-3",
    className: "fill-cyan"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "43.7576451",
    y1: "61.2298793",
    x2: "0.000107942022",
    y2: "61.2298793",
    id: "Stroke-5",
    className: "stroke-dark",
    strokeWidth: "2.25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21.8788765",
    y1: "5.50235861",
    x2: "21.8788765",
    y2: 0,
    id: "Stroke-7",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  })), /*#__PURE__*/React.createElement("line", {
    x1: "45.6264453",
    y1: "9.0900477",
    x2: "48.3751889",
    y2: "4.32457835",
    id: "Stroke-10",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "55.4187837",
    y1: "18.8919715",
    x2: "60.1795666",
    y2: "16.1405221",
    id: "Stroke-11",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "59.0030525",
    y1: "32.2816384",
    x2: "64.5",
    y2: "32.2816384",
    id: "Stroke-12",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "18.8734468",
    y1: "9.09015575",
    x2: "16.1247032",
    y2: "4.3246864",
    id: "Stroke-14",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "9.08116236",
    y1: "18.8920795",
    x2: "4.32037945",
    y2: "16.1406301",
    id: "Stroke-15",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "5.4969475",
    y1: "32.2818005",
    x2: 0,
    y2: "32.2818005",
    id: "Stroke-16",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  })))))))), /*#__PURE__*/React.createElement(Link, {
    to: "/Payoff/PurchaseHome",
    onClick: function () {
      return onClick(translations.PurchaseaNewHome);
    },
    id: "cta-1-btn",
    className: "btn btn-lg px-3 py-2 smaller text-uppercase bg-pennymac-yellow font-weight-bold text-pennymac-black mt-3"
  }, translations.PurchaseaNewHome, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })));
}
function RefinancewithPennyMac(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement("a", {
    id: "cta-3",
    href: true,
    className: "px-5 py-4 no-underline cta-hover icon-fill",
    style: {
      borderLeft: '1px solid #31AFDF'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 38,
    height: 46,
    alt: "rate icon",
    className: "mx-auto d-block",
    viewBox: "0 0 42 51",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "1B97ACAB-5454-4ACB-AC28-861D2B849EC8"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 42 0 42 42.8755335 0 42.8755335"
  })), /*#__PURE__*/React.createElement("g", {
    id: "home-page-desktop-r6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pnmc-homepage-2022-desktop-v1-r6",
    transform: "translate(-710.000000, -755.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(534.000000, 727.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/rate",
    transform: "translate(176.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000233, 0.000046)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "fill-dark-cyan",
    points: "41.9997669 20.78302 20.9999068 20.78302 20.9999068 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "41.9997203",
    y1: "49.7692467",
    x2: 0,
    y2: "49.7692467",
    id: "Stroke-3",
    className: "stroke-dark",
    strokeWidth: "1.86923077"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "fill-cyan",
    points: "32.2617473 16.7749452 30.4005635 14.9329796 24.4887872 20.7832507 28.2116211 20.7832507"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3139249,38.0694428 C27.3166024,38.0694428 25.6973911,36.4669512 25.6973911,34.4902526 C25.6973911,32.513554 27.3166024,30.9110624 29.3139249,30.9110624 C31.3112474,30.9110624 32.9304587,32.513554 32.9304587,34.4902526 C32.9304587,36.4669512 31.3112474,38.0694428 29.3139249,38.0694428 L29.3139249,38.0694428 Z M8.95792622,17.9236359 C8.95792622,15.9469374 10.5771375,14.3439843 12.57446,14.3439843 C14.5717825,14.3439843 16.1909938,15.9469374 16.1909938,17.9236359 L16.1909938,17.9236359 C16.1909938,19.9003345 14.5717825,21.5028262 12.57446,21.5028262 C10.5771375,21.5028262 8.95792622,19.9003345 8.95792622,17.9236359 Z M28.2117609,20.78302 L11.2900007,37.5300496 L9.42881691,35.6876226 L24.4889271,20.78302 L21.0001399,20.78302 L21.0001399,0 L-0.000186491365,20.78302 L-0.000186491365,42.8755335 L42,42.8755335 L42,20.78302 L28.2117609,20.78302 Z",
    id: "Fill-8",
    className: "fill-cyan",
    mask: "url(#mask-2)"
  })))))))), /*#__PURE__*/React.createElement(Link, {
    to: '/Payoff/RefinancePennyMac',
    onClick: function () {
      return onClick(translations.RefinancewithPennyMac);
    },
    id: "cta-1-btn",
    className: "btn btn-lg px-3 py-2 smaller text-uppercase bg-pennymac-yellow font-weight-bold text-pennymac-black mt-3"
  }, translations.RefinancewithPennyMac, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })));
}
function RefinancewithAnotherLender(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement("div", {
    id: "cta-4",
    className: "px-5 py-4 no-underline cta-hover icon-fill",
    style: {
      borderLeft: '1px solid #31AFDF'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 26,
    height: 52,
    alt: "contact icon",
    className: "mx-auto d-block",
    style: {
      marginTop: '-6px'
    },
    viewBox: "0 0 25 50",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "3DD858B7-7AB7-428A-B6A8-CC5C92EECCFB"), /*#__PURE__*/React.createElement("g", {
    id: "home-page-desktop-r6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pnmc-homepage-2022-desktop-v1-r6",
    transform: "translate(-1183.000000, -760.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(534.000000, 727.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/contact",
    transform: "translate(649.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "fill-cyan",
    points: "0 45.2328095 24.9998795 45.2328095 24.9998795 7.94002423e-05 0 7.94002423e-05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "fill-darker-cyan",
    points: "25 0 0.000120516195 45.2327301 25 45.2327301"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "24.9999197",
    y1: "49.1960725",
    x2: "4.0172065e-05",
    y2: "49.1960725",
    id: "Stroke-3",
    className: "stroke-dark",
    strokeWidth: "1.60785491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2352428,40.8526554 L13.7648777,40.8526554 C13.9287797,40.8526554 14.062151,40.9844598 14.062151,41.1464363 L14.062151,43.680892 C14.062151,43.8432655 13.9287797,43.9746729 13.7648777,43.9746729 L11.2352428,43.9746729 C11.070939,43.9746729 10.9379695,43.8432655 10.9379695,43.680892 L10.9379695,41.1464363 C10.9379695,40.9844598 11.070939,40.8526554 11.2352428,40.8526554",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    points: "2.49629212 39.4671609 22.3923107 39.4671609 22.3923107 2.74296077 2.49629212 2.74296077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#E9E9E9",
    points: "22.3925116 2.74307987 2.49649298 39.46728 22.3925116 39.46728"
  })))))), /*#__PURE__*/React.createElement(Link, {
    to: '/Payoff/RefinanceAnotherLender',
    onClick: function () {
      return onClick(translations.RefinancewithAnotherLender);
    },
    id: "cta-1-btn",
    className: "btn btn-lg px-3 py-2 smaller text-uppercase bg-pennymac-yellow font-weight-bold text-pennymac-black mt-3"
  }, translations.RefinancewithAnotherLender, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })));
}
function PayMyMortgageinFull(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement("a", {
    id: "cta-5",
    href: true,
    className: "px-5 py-4 no-underline cta-hover icon-fill",
    style: {
      borderLeft: '1px solid #31AFDF',
      borderTopRightRadius: '0.25rem !important',
      borderBottomRightRadius: '0.25rem !important'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 38,
    height: 46,
    alt: "cash-out icon",
    className: "mx-auto d-block",
    viewBox: "0 0 51 63",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "6AFD8A7C-FC91-4CA4-8A4D-9E3D4637AED2"), /*#__PURE__*/React.createElement("g", {
    id: "navigation-drawers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/desktop/drawer/buy-home",
    transform: "translate(-377.000000, -231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(0.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(365.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(12.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 6.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "fill-dark-cyan",
    points: "51 25.5632045 25.5001415 25.5632045 25.5001415 0.000113507797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4541125,42.4706449 L41.4541125,35.5846944 C41.4541125,35.2436034 41.1784047,34.9672119 40.8381575,34.9672119 L33.96924,34.9672119 C33.6289928,34.9672119 33.353285,35.2436034 33.353285,35.5846944 L33.353285,42.4706449 C33.353285,42.8117358 33.6289928,43.0881273 33.96924,43.0881273 L40.8381575,43.0881273 C41.1784047,43.0881273 41.4541125,42.8117358 41.4541125,42.4706449 L41.4541125,42.4706449 Z M50.9997169,25.563091 L50.9997169,52.7374251 L0,52.7374251 L0,25.563091 L25.4998585,0 L25.4998585,25.563091 L50.9997169,25.563091 Z",
    id: "Fill-3",
    className: "fill-cyan"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "50.9999434",
    y1: "61.2162305",
    x2: "0.000226454051",
    y2: "61.2162305",
    id: "Stroke-5",
    className: "stroke-dark",
    strokeWidth: "2.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(1.130062, 5.159270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7684618,10.9115045 C21.7684618,16.9376335 16.8951706,21.823009 10.8839478,21.823009 C4.87329119,21.823009 0,16.9376335 0,10.9115045 C0,4.88537558 4.87329119,0 10.8839478,0 C16.8951706,0 21.7684618,4.88537558 21.7684618,10.9115045",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7684618,10.9115045 C21.7684618,16.9376335 16.8951706,21.823009 10.8839478,21.823009 C4.87329119,21.823009 0,16.9376335 0,10.9115045 C0,4.88537558 4.87329119,0 10.8839478,0 C16.8951706,0 21.7684618,4.88537558 21.7684618,10.9115045 Z",
    id: "Stroke-10",
    className: "stroke-cyan",
    strokeWidth: "1.70797531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0340514,16.7805954 L12.0340514,18.5950176 L10.0769222,18.5950176 L10.0769222,16.8458624 C8.44645305,16.7312195 6.89694121,16.2573245 5.95206168,15.6023845 L7.0113005,13.2164506 C8.02298398,13.8872817 9.45700426,14.3447181 10.7777975,14.3447181 C12.1150087,14.3447181 12.6369853,13.9684398 12.6369853,13.4133866 C12.6369853,11.5978294 6.14681216,12.9218979 6.14681216,8.67216595 C6.14681216,6.87420245 7.43646798,5.35376551 10.0769222,5.02629551 L10.0769222,3.22833201 L12.0340514,3.22833201 L12.0340514,4.99451333 C13.2410515,5.09156249 14.4305014,5.41903249 15.3442435,5.95819452 L14.349544,8.36228966 C13.2569032,7.77375174 12.1801142,7.47806393 11.1854148,7.47806393 C9.83291798,7.47806393 9.34264496,7.93606789 9.34264496,8.50814718 C9.34264496,10.2573023 15.8169663,8.95026005 15.8169663,13.1670747 C15.8169663,14.8997712 14.5776965,16.4037495 12.0340514,16.7805954",
    id: "Fill-12",
    className: "fill-cyan"
  }))))))))), /*#__PURE__*/React.createElement(Link, {
    to: '/Payoff/PayMortgage',
    onClick: function () {
      return onClick(translations.PayMyMortgageinFull);
    },
    id: "cta-2-btn",
    className: "btn btn-lg px-3 py-2 smaller text-uppercase bg-pennymac-yellow font-weight-bold text-pennymac-black mt-3"
  }, translations.PayMyMortgageinFull, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })));
}
function SellMyHomeSmall(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement(Link, {
    to: '/Payoff/SellMyHome',
    onClick: function () {
      return onClick(translations.SellMyHome);
    },
    className: "media cta-hover icon-fill",
    style: {
      paddingTop: 10,
      paddingBottom: 10,
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-self-center",
    style: {
      width: '65px'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 65,
    width: 65,
    style: {
      marginBottom: '-19px'
    },
    alt: "for sale icon",
    className: "mx-auto d-block",
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 51"
  }, /*#__PURE__*/React.createElement("style", {
    className: 'htmlToNative',
    type: "text/css",
    dangerouslySetInnerHTML: {
      __html: "\n                    .cta1-0 {\n                        fill: none;\n                        stroke-width: 1.5;\n                    }\n\n                    .cta1-1 {\n                        fill-rule: evenodd;\n                        clip-rule: evenodd;\n                    }\n\n                    .cta1-2 {\n                        fill-rule: evenodd;\n                        clip-rule: evenodd;\n                    }\n\n                    .cta1-3 {\n                        filter: url(#Adobe_OpacityMaskFilter);\n                    }\n\n                    .cta1-4 {\n                        fill-rule: evenodd;\n                        clip-rule: evenodd;\n                        fill: #FFFFFF;\n                    }\n\n                    .cta1-5 {\n                        mask: url(#mask-2_00000075850803038374858620000007343692463584097924_);\n                        fill-rule: evenodd;\n                        clip-rule: evenodd;\n                    }\n                "
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_x2F_positive_x2F_for-sale"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(4.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Stroke-1",
    className: "cta1-0 stroke-dark",
    x1: 38,
    y1: 28,
    x2: -4,
    y2: 28
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "cta1-1 fill-light-cyan",
    points: "25.7,22.9 28.1,22.9 28.1,-7 25.7,-7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    className: "cta1-1 fill-light-cyan",
    points: "14.2,-4.6 28.1,-4.6 28.1,-7 14.2,-7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "cta1-1 fill-light-cyan",
    points: "14.2,6.8 16.6,6.8 16.6,-7 14.2,-7    "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cta1-2 fill-cyan",
    d: "M32,14.3H1.4c-0.8,0-1.4-0.6-1.4-1.4V-1.4c0-0.8,0.6-1.4,1.4-1.4H32c0.8,0,1.4,0.6,1.4,1.4v14.3\r\n        C33.4,13.6,32.8,14.3,32,14.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(4.028156, 4.163957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -4,
    y: -7,
    width: "33.4",
    height: "17.1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -7,
    width: "33.4",
    height: "17.1",
    id: "mask-2_00000075850803038374858620000007343692463584097924_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cta1-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000152985556804155392500000007054273704212707505_",
    className: "cta1-4",
    d: "M-2.5-7C-3.3-7-4-6.3-4-5.5l0,0V8.6\r\n              c0,0.8,0.7,1.5,1.5,1.5l0,0h30.4c0.8,0,1.5-0.7,1.5-1.5l0,0V-5.5c0-0.8-0.7-1.5-1.5-1.5l0,0H-2.5z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "cta1-5 fill-dark-cyan",
    points: "29.4,10.1 -4,10.1 29.4,-7       "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(8.982461, 5.930020)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    className: "cta1-4",
    points: "-1.8,-5.5 -1.8,-4.1 1.1,-4.1 1.1,-2.7 -1.8,-2.7 -1.8,-0.6 -3.6,-0.6 -3.6,-6.9\r\n          1.4,-6.9 1.4,-5.5       "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "cta1-4",
    d: "M7.2-3.7c0-1.1-0.8-1.8-1.7-1.8S3.7-4.8,3.7-3.7c0,1.1,0.8,1.8,1.7,1.8S7.2-2.6,7.2-3.7\r\n           M1.9-3.7C1.9-5.6,3.4-7,5.4-7S9-5.6,9-3.7c0,1.9-1.5,3.3-3.5,3.3S1.9-1.8,1.9-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "cta1-4",
    d: "M12.7-5.5h-1v1.8h1c0.7,0,1.1-0.3,1.1-0.9C13.8-5.1,13.5-5.5,12.7-5.5L12.7-5.5z M12.7-2.2h-1\r\n          v1.7H9.9v-6.3h2.9c1.7,0,2.8,0.9,2.8,2.3c0,0.9-0.5,1.6-1.2,2l1.4,2h-1.9L12.7-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "cta1-4",
    d: "M-4,6.2l0.6-1.3C-2.8,5.3-2,5.5-1.3,5.5c0.7,0,1-0.2,1-0.5c0-1-3.6-0.3-3.6-2.6\r\n          c0-1.1,0.9-2,2.8-2c0.8,0,1.7,0.2,2.3,0.5L0.7,2.2C0.1,1.9-0.5,1.7-1.1,1.7c-0.8,0-1,0.3-1,0.6c0,1,3.6,0.2,3.6,2.6\r\n          c0,1.1-0.9,2-2.8,2C-2.4,6.9-3.4,6.6-4,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "cta1-4",
    d: "M6.1,4.3l-0.8-2l-0.8,2H6.1z M6.6,5.6H3.9L3.4,6.8H1.6l2.8-6.3h1.8L9,6.8H7.1L6.6,5.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    className: "cta1-4",
    points: "9.5,0.5 11.3,0.5 11.3,5.4 14.3,5.4 14.3,6.8 9.5,6.8       "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    className: "cta1-4",
    points: "20.1,5.4 20.1,6.8 15,6.8 15,0.5 20,0.5 20,1.9 16.8,1.9 16.8,2.9 19.6,2.9 19.6,4.3\r\n          16.8,4.3 16.8,5.4       "
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "media-body align-self-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("a", {
    className: "text-uppercase no-underline text-pennymac-gray-darkest smaller heading-font"
  }, translations.SellMyHome, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })))));
}
function PurchaseaNewHomeSmall(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement(Link, {
    to: "/Payoff/PurchaseHome",
    onClick: function () {
      return onClick(translations.PurchaseaNewHome);
    },
    className: "media mt-2 cta-hover icon-fill",
    style: {
      paddingTop: 10,
      paddingBottom: 10,
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-self-center",
    style: {
      width: '65px'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 54,
    height: 54,
    style: {
      marginTop: '-6px',
      marginBottom: '-2px'
    },
    className: "mx-auto d-block",
    viewBox: "0 0 65 63",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "811FB8EA-EB50-47AE-8F73-1BD311BDA7CC"), /*#__PURE__*/React.createElement("g", {
    id: "navigation-drawers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/desktop/drawer/buy-home",
    transform: "translate(-371.000000, -315.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(0.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(365.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(0.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(6.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.371070, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "fill-dark-cyan",
    points: "43.757699 30.6854952 21.8789305 30.6854952 21.8789305 8.78518948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5674362,45.1703394 L35.5674362,39.2709034 C35.5674362,38.9786328 35.3310431,38.7420071 35.03906,38.7420071 L29.1454255,38.7420071 C28.8534423,38.7420071 28.6165096,38.9786328 28.6165096,39.2709034 L28.6165096,45.1703394 C28.6165096,45.46261 28.8534423,45.6992358 29.1454255,45.6992358 L35.03906,45.6992358 C35.3310431,45.6992358 35.5674362,45.46261 35.5674362,45.1703394 L35.5674362,45.1703394 Z M43.7575371,30.6853871 L43.7575371,53.9660096 L0,53.9660096 L0,30.6853871 L21.8787686,8.78508143 L21.8787686,30.6853871 L43.7575371,30.6853871 Z",
    id: "Fill-3",
    className: "fill-cyan"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "43.7576451",
    y1: "61.2298793",
    x2: "0.000107942022",
    y2: "61.2298793",
    id: "Stroke-5",
    className: "stroke-dark",
    strokeWidth: "2.25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21.8788765",
    y1: "5.50235861",
    x2: "21.8788765",
    y2: 0,
    id: "Stroke-7",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  })), /*#__PURE__*/React.createElement("line", {
    x1: "45.6264453",
    y1: "9.0900477",
    x2: "48.3751889",
    y2: "4.32457835",
    id: "Stroke-10",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "55.4187837",
    y1: "18.8919715",
    x2: "60.1795666",
    y2: "16.1405221",
    id: "Stroke-11",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "59.0030525",
    y1: "32.2816384",
    x2: "64.5",
    y2: "32.2816384",
    id: "Stroke-12",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "18.8734468",
    y1: "9.09015575",
    x2: "16.1247032",
    y2: "4.3246864",
    id: "Stroke-14",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "9.08116236",
    y1: "18.8920795",
    x2: "4.32037945",
    y2: "16.1406301",
    id: "Stroke-15",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "5.4969475",
    y1: "32.2818005",
    x2: 0,
    y2: "32.2818005",
    id: "Stroke-16",
    className: "stroke-cyan",
    strokeWidth: "1.61856322"
  }))))))))), /*#__PURE__*/React.createElement("div", {
    className: "media-body align-self-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("a", {
    className: "text-uppercase no-underline text-pennymac-gray-darkest smaller heading-font"
  }, translations.PurchaseaNewHome, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })))));
}
function RefinancewithPennyMacSmall(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement(Link, {
    to: '/Payoff/RefinancePennyMac',
    onClick: function () {
      return onClick(translations.RefinancewithPennyMac);
    },
    className: "media mt-3 cta-hover icon-fill",
    style: {
      paddingTop: 10,
      paddingBottom: 10,
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-self-center",
    style: {
      width: '65px'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 38,
    height: 46,
    alt: "rate icon",
    className: "mx-auto d-block",
    viewBox: "0 0 42 51",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "1B97ACAB-5454-4ACB-AC28-861D2B849EC8"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 42 0 42 42.8755335 0 42.8755335"
  })), /*#__PURE__*/React.createElement("g", {
    id: "home-page-desktop-r6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pnmc-homepage-2022-desktop-v1-r6",
    transform: "translate(-710.000000, -755.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(534.000000, 727.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/rate",
    transform: "translate(176.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000233, 0.000046)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "fill-dark-cyan",
    points: "41.9997669 20.78302 20.9999068 20.78302 20.9999068 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "41.9997203",
    y1: "49.7692467",
    x2: 0,
    y2: "49.7692467",
    id: "Stroke-3",
    className: "stroke-dark",
    strokeWidth: "1.86923077"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "fill-cyan",
    points: "32.2617473 16.7749452 30.4005635 14.9329796 24.4887872 20.7832507 28.2116211 20.7832507"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3139249,38.0694428 C27.3166024,38.0694428 25.6973911,36.4669512 25.6973911,34.4902526 C25.6973911,32.513554 27.3166024,30.9110624 29.3139249,30.9110624 C31.3112474,30.9110624 32.9304587,32.513554 32.9304587,34.4902526 C32.9304587,36.4669512 31.3112474,38.0694428 29.3139249,38.0694428 L29.3139249,38.0694428 Z M8.95792622,17.9236359 C8.95792622,15.9469374 10.5771375,14.3439843 12.57446,14.3439843 C14.5717825,14.3439843 16.1909938,15.9469374 16.1909938,17.9236359 L16.1909938,17.9236359 C16.1909938,19.9003345 14.5717825,21.5028262 12.57446,21.5028262 C10.5771375,21.5028262 8.95792622,19.9003345 8.95792622,17.9236359 Z M28.2117609,20.78302 L11.2900007,37.5300496 L9.42881691,35.6876226 L24.4889271,20.78302 L21.0001399,20.78302 L21.0001399,0 L-0.000186491365,20.78302 L-0.000186491365,42.8755335 L42,42.8755335 L42,20.78302 L28.2117609,20.78302 Z",
    id: "Fill-8",
    className: "fill-cyan",
    mask: "url(#mask-2)"
  }))))))))), /*#__PURE__*/React.createElement("div", {
    className: "media-body align-self-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("a", {
    className: "text-uppercase no-underline text-pennymac-gray-darkest smaller heading-font"
  }, translations.RefinancewithPennyMac, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })))));
}
function RefinancewithAnotherLenderSmall(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement(Link, {
    to: '/Payoff/RefinanceAnotherLender',
    onClick: function () {
      return onClick(translations.RefinancewithAnotherLender);
    },
    className: "media mt-3 cta-hover icon-fill",
    style: {
      paddingTop: 10,
      paddingBottom: 10,
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-self-center",
    style: {
      width: '65px'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 26,
    height: 52,
    alt: "contact icon",
    className: "mx-auto d-block",
    style: {
      marginTop: '-6px'
    },
    viewBox: "0 0 25 50",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "3DD858B7-7AB7-428A-B6A8-CC5C92EECCFB"), /*#__PURE__*/React.createElement("g", {
    id: "home-page-desktop-r6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pnmc-homepage-2022-desktop-v1-r6",
    transform: "translate(-1183.000000, -760.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(534.000000, 727.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/contact",
    transform: "translate(649.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "fill-cyan",
    points: "0 45.2328095 24.9998795 45.2328095 24.9998795 7.94002423e-05 0 7.94002423e-05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "fill-darker-cyan",
    points: "25 0 0.000120516195 45.2327301 25 45.2327301"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "24.9999197",
    y1: "49.1960725",
    x2: "4.0172065e-05",
    y2: "49.1960725",
    id: "Stroke-3",
    className: "stroke-dark",
    strokeWidth: "1.60785491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2352428,40.8526554 L13.7648777,40.8526554 C13.9287797,40.8526554 14.062151,40.9844598 14.062151,41.1464363 L14.062151,43.680892 C14.062151,43.8432655 13.9287797,43.9746729 13.7648777,43.9746729 L11.2352428,43.9746729 C11.070939,43.9746729 10.9379695,43.8432655 10.9379695,43.680892 L10.9379695,41.1464363 C10.9379695,40.9844598 11.070939,40.8526554 11.2352428,40.8526554",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    points: "2.49629212 39.4671609 22.3923107 39.4671609 22.3923107 2.74296077 2.49629212 2.74296077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#E9E9E9",
    points: "22.3925116 2.74307987 2.49649298 39.46728 22.3925116 39.46728"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "media-body align-self-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("a", {
    className: "text-uppercase no-underline text-pennymac-gray-darkest smaller heading-font"
  }, translations.RefinancewithAnotherLender, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })))));
}
function PayMyMortgageinFullSmall(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement(Link, {
    to: '/Payoff/PayMortgage',
    onClick: function () {
      return onClick(translations.PayMyMortgageinFull);
    },
    className: "media mt-3 cta-hover icon-fill",
    style: {
      paddingTop: 10,
      paddingBottom: 10,
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-self-center",
    style: {
      width: '65px'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 38,
    height: 46,
    alt: "cash-out icon",
    className: "mx-auto d-block",
    viewBox: "0 0 51 63",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "6AFD8A7C-FC91-4CA4-8A4D-9E3D4637AED2"), /*#__PURE__*/React.createElement("g", {
    id: "navigation-drawers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/desktop/drawer/buy-home",
    transform: "translate(-377.000000, -231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(0.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(365.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(12.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 6.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "fill-dark-cyan",
    points: "51 25.5632045 25.5001415 25.5632045 25.5001415 0.000113507797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4541125,42.4706449 L41.4541125,35.5846944 C41.4541125,35.2436034 41.1784047,34.9672119 40.8381575,34.9672119 L33.96924,34.9672119 C33.6289928,34.9672119 33.353285,35.2436034 33.353285,35.5846944 L33.353285,42.4706449 C33.353285,42.8117358 33.6289928,43.0881273 33.96924,43.0881273 L40.8381575,43.0881273 C41.1784047,43.0881273 41.4541125,42.8117358 41.4541125,42.4706449 L41.4541125,42.4706449 Z M50.9997169,25.563091 L50.9997169,52.7374251 L0,52.7374251 L0,25.563091 L25.4998585,0 L25.4998585,25.563091 L50.9997169,25.563091 Z",
    id: "Fill-3",
    className: "fill-cyan"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "50.9999434",
    y1: "61.2162305",
    x2: "0.000226454051",
    y2: "61.2162305",
    id: "Stroke-5",
    className: "stroke-dark",
    strokeWidth: "2.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(1.130062, 5.159270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7684618,10.9115045 C21.7684618,16.9376335 16.8951706,21.823009 10.8839478,21.823009 C4.87329119,21.823009 0,16.9376335 0,10.9115045 C0,4.88537558 4.87329119,0 10.8839478,0 C16.8951706,0 21.7684618,4.88537558 21.7684618,10.9115045",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7684618,10.9115045 C21.7684618,16.9376335 16.8951706,21.823009 10.8839478,21.823009 C4.87329119,21.823009 0,16.9376335 0,10.9115045 C0,4.88537558 4.87329119,0 10.8839478,0 C16.8951706,0 21.7684618,4.88537558 21.7684618,10.9115045 Z",
    id: "Stroke-10",
    className: "stroke-cyan",
    strokeWidth: "1.70797531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0340514,16.7805954 L12.0340514,18.5950176 L10.0769222,18.5950176 L10.0769222,16.8458624 C8.44645305,16.7312195 6.89694121,16.2573245 5.95206168,15.6023845 L7.0113005,13.2164506 C8.02298398,13.8872817 9.45700426,14.3447181 10.7777975,14.3447181 C12.1150087,14.3447181 12.6369853,13.9684398 12.6369853,13.4133866 C12.6369853,11.5978294 6.14681216,12.9218979 6.14681216,8.67216595 C6.14681216,6.87420245 7.43646798,5.35376551 10.0769222,5.02629551 L10.0769222,3.22833201 L12.0340514,3.22833201 L12.0340514,4.99451333 C13.2410515,5.09156249 14.4305014,5.41903249 15.3442435,5.95819452 L14.349544,8.36228966 C13.2569032,7.77375174 12.1801142,7.47806393 11.1854148,7.47806393 C9.83291798,7.47806393 9.34264496,7.93606789 9.34264496,8.50814718 C9.34264496,10.2573023 15.8169663,8.95026005 15.8169663,13.1670747 C15.8169663,14.8997712 14.5776965,16.4037495 12.0340514,16.7805954",
    id: "Fill-12",
    className: "fill-cyan"
  })))))))))), /*#__PURE__*/React.createElement("div", {
    className: "media-body align-self-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("a", {
    className: "text-uppercase no-underline text-pennymac-gray-darkest smaller heading-font"
  }, translations.PayMyMortgageinFull, " ", /*#__PURE__*/React.createElement("i", {
    className: "fas fa-caret-right ml-2"
  })))));
}
function PayoffTitle(_a) {
  var translations = _a.translations,
    onClick = _a.onClick;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 20,
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid d-none d-lg-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white shadowed d-flex justify-content-between rounded"
  }, /*#__PURE__*/React.createElement(SellMyHome, {
    translations: translations,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(PurchaseaNewHome, {
    translations: translations,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(RefinancewithPennyMac, {
    translations: translations,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(RefinancewithAnotherLender, {
    translations: translations,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(PayMyMortgageinFull, {
    translations: translations,
    onClick: onClick
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-block d-lg-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 bg-white align-self-center shadowed rounded"
  }, /*#__PURE__*/React.createElement(SellMyHomeSmall, {
    translations: translations,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(PurchaseaNewHomeSmall, {
    translations: translations,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(RefinancewithPennyMacSmall, {
    translations: translations,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(RefinancewithAnotherLenderSmall, {
    translations: translations,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(PayMyMortgageinFullSmall, {
    translations: translations,
    onClick: onClick
  })))));
}
export default PayoffTitle;